import React from "react";
import { useTranslation } from "react-i18next";

const KsaLebaraTerms = () => {
  const { t } = useTranslation();

  return (
    <div className="terms mx-5 ">
      <h4 className="text-center">{t("iraq-zain.TERMS AND CONDITIONS")}</h4>
      <ul className="list-unstyled text-center px-0" dir="auto">
        <li>{t("ksa.TermsAndConditions")}</li>
      </ul>
    </div>
  );
};

export default KsaLebaraTerms;
